import React, { useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, countries2, deepClone, generateDiffDot } from '../utils'
import Loading from './Loading'
import { useDispatch, useSelector } from 'react-redux'
import { db } from '../firebase'
import { doc, updateDoc } from 'firebase/firestore'
import { redNex } from '../Redux/nexSlice'

function TopSearchQueries({ nexListn, _nex }) {
    const [data, setData] = useState([])
    const [url, setUrl] = useState('')
    const [location, setLocation] = useState('')

    const [isLoading, setIsLoading] = useState(false)

    const [noInput1, setNoInput1] = useState(false)
    const [noInput2, setNoInput2] = useState(false)

    const user = useSelector(state=> state.user.user)
    const nx = useSelector(state=> state.nex.nex)

    const dispatch = useDispatch()


    const getData = async () => {
        if(url !== '' && location !== '') {
          setNoInput1(false)
          setNoInput2(false)
          
          const updateAnalytics = async () => {
            const tool = window.location.pathname.split('/').pop();
            let tools = deepClone(user.analytics.toolsUsage);
        
            if (isNaN(tools[tool]) || tools[tool] == 'NaN') {
                tools[tool] = 1;
            } else {
                tools[tool] = Number(tools[tool]) + 1;
            }
        
            await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
        };

          setIsLoading(true)
            fetch(`${base}/res`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                type: 'tsq',
                url: url,
                location: location,
                userId: user.id
              })
            }).then(res=> res.json()).then(data=> {
                const sortedData = [...data].sort((a, b) => {
                    if (a.rank === 'na') return 1;
                    if (b.rank === 'na') return -1;
                    return a.rank - b.rank;
                })
              setData(sortedData)
              setIsLoading(false)
              dispatch(redNex(nx))
              updateAnalytics()
            })
          } else {
            if(url.trim() === '') setNoInput1(true)
            if(location.trim() === '') setNoInput2(true)
          }
    }



  return (
    <TopSearchQueriesContainer>
        <TopSearchQueriesInputContainer>
        <h2>Top Search Queries <span style={{fontSize: 'medium', marginLeft: '20px'}}>Top searched keywords for a website</span></h2>
            <TopSearchQueriesInputInnerContainer>
                <div style={{position: 'relative', marginBottom: '20px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '23px', top: '20%', fontSize: 'small'}}>Website or Webpage</label><input type='url' placeholder='example.com' style={{marginLeft: '20px', borderColor: noInput1? 'red': ''}} value={url} onChange={e=> setUrl(e.target.value)}/></div>
                <select name="country" value={location} onChange={e=> setLocation(e.target.value)} className='select-country' style={noInput2? {borderColor: 'red'}: {}}>
                    {countries2()}
                </select>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Get Data': 'Getting Data ...'}</button>}
          {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
            </TopSearchQueriesInputInnerContainer>
        </TopSearchQueriesInputContainer>

        {data?.length !== 0 && !isLoading && <TopSearchQueriesResContainer>
                        <TopSearchQueriesRes>
                        <p style={{width: '120px', fontSize: 'medium', fontSize: 'small'}}>Keyword</p>
                        <p style={{width: '20px', fontSize: 'medium', fontSize: 'small'}}>Rank</p>
                        <p style={{width: '160px', fontSize: 'medium', fontSize: 'small'}}>Volume</p>
                        <p style={{width: '60px', fontSize: 'medium', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px', fontSize: 'small'}}>Difficulty</p>
                        <p style={{width: '90px', fontSize: 'medium', fontSize: 'small'}}>Clicks</p>
                        <p style={{width: '25px', fontSize: 'medium', fontSize: 'small'}}>CPC</p>
                        <p style={{width: '20px', fontSize: 'medium', fontSize: 'small'}}>Homepages</p>
                        </TopSearchQueriesRes>
        {data?.map(tsq=> {
                return (
                    <>
                        <TopSearchQueriesRes key={tsq.keyword}>
                        <p style={{width: '120px', fontSize: 'medium'}}>{tsq.keyword}</p>
                        <p style={{width: '20px', fontSize: 'medium'}}>{tsq.rank}</p>
                        <p style={{width: '160px', fontSize: 'medium'}}>{tsq.volume}</p>
                        <p style={{width: '60px', fontSize: 'medium', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>{generateDiffDot(10, tsq.difficulty)}{tsq.difficulty}</p>
                        <p style={{width: '90px', fontSize: 'medium'}}>{tsq.clicks}</p>
                        <p style={{width: '25px', fontSize: 'medium'}}>{tsq.cpc}</p>
                        <p style={{width: '20px', fontSize: 'medium'}}>{tsq.homePages}</p>
                        </TopSearchQueriesRes>
                    </>
                )
            })}
        </TopSearchQueriesResContainer>}
        {isLoading && <Loading />}

        {data.length == 0 && !isLoading && <Intro>

          <h3>Tool Overview</h3>
          <br />
          <p>
            The Top Search Queries Tool reveals the most frequently searched keywords that drive traffic to a website. 
            By analyzing these queries, you can gain insights into popular search terms, optimize your content, and enhance your SEO strategy.
          </p>
          <br /><br />
          
          <h3>Instructions</h3>
          <br />
          <p>1. Enter the URL of the website you want to analyze</p>
          <p>2. Click "Get Data" to see the list of top searched keywords</p>
          <br /><br />
          
          <h3>Tips</h3>
          <br />
          <p>Focus on the most common search queries to tailor your content and improve your site’s visibility based on popular search terms</p>
        </Intro>}
    </TopSearchQueriesContainer>
  )
}

export default TopSearchQueries


const TopSearchQueriesContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const TopSearchQueriesInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--se-color);
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: var(--se-color);
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: var(--se-color);
    color: white;
  }

  > div > button:hover {
    color: var(--se-color);
    background-color: rgb(239, 239, 239);
  }
`


const TopSearchQueriesInputInnerContainer = styled.div`
  display: flex;
  margin-top: 20px;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: var(--se-color);
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }
`


const TopSearchQueriesResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;
`


const TopSearchQueriesRes = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);
    gap: 80px;

    > p {
        display: flex;
    }
`


const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`